import { FC } from 'react'

import ReactCountryFlag from 'react-country-flag'
import { IconCellTypes } from './icon-cell.types'

export const IconCell: FC<IconCellTypes> = ({
  upperText,
  upperNumber,
  bottomText,
  countryCode = null,
}) => {
  return (
    <div className="max-w-32 flex w-fit flex-col items-center justify-center">
      {/* text replaced with grey-95 */}
      <div className="flex w-full items-center justify-around gap-x-1 text-grey-95"> 
        <p className="m-0 w-fit max-w-[128px] overflow-hidden text-ellipsis whitespace-nowrap font-montserrat text-sm font-semibold md:max-w-[192px] lg:max-w-[256px]">
          {upperText}
        </p>
        <div className="flex items-center">
          <p className="m-0 font-montserrat text-sm font-semibold">
            {upperNumber}
          </p>
          <p className="m-0 font-montserrat text-sm font-semibold md:text-xs md:font-normal lg:text-xs lg:font-normal">
            %
          </p>
        </div>
        {countryCode && countryCode !== null && (
          <ReactCountryFlag
            countryCode={countryCode.toUpperCase()}
            svg
            className="h-3 w-4 rounded-sm"
          />
        )}
      </div>
      <div>
        <p className="m-0 mt-0.5 font-montserrat text-xs font-light text-grey-50">
          {bottomText}
        </p>
      </div>
    </div>
  )
}